// 组件/pages/orders/signContract/list
import EnterpriseLeaseChildOrder from '../components/EnterpriseLeaseChildOrder.vue'
import EnterpriseLeasePrimaryOrder from '../components/EnterpriseLeasePrimaryOrder.vue'
import PersonalLeaseOrder from '../components/PersonalLeaseOrder.vue'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
// api
import { getLeaseOrderList, PurchaseAndSeven } from '@/api/purchaseAndSaleAPI'
// 其他
import selectOptionDict from '@/store/dict/selectOptionDict'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default function config() {
  // 签约提车订单列表tabs
  const c_signContractTabsList = [
    {
      label: '个人租赁订单',
      name: 'personal',
      number: 0,
      resourcesKey: 'for_rent_sign_contract_rent_order',
      components: PersonalLeaseOrder,
    }, {
      label: '企业租赁主订单',
      name: 'primary',
      number: 0,
      resourcesKey: 'for_rent_sign_contract_ent_rent_order_main',
      components: EnterpriseLeasePrimaryOrder,
    }, {
      label: '企业租赁子订单',
      name: 'child',
      number: 0,
      resourcesKey: 'for_rent_sign_contract_ent_rent_order_sub',
      components: EnterpriseLeaseChildOrder,
    },
  ]

  // 个人租赁订单tabs
  const c_personalTabsList = [
    {
      label: '全部',
      number: 0,
      name: '1',
    }, {
      label: '待绑车',
      number: 0,
      name: '5',
    }, {
      label: '合同待签署',
      number: 0,
      name: '11',
    }, {
      label: '订单待支付',
      number: 0,
      name: '13',
    }, {
      label: '发车待验车',
      number: 0,
      name: '12',
    },
  ]

  // 企业租赁订单tabs
  const c_enterpriseTabsList = [
    {
      label: '全部',
      number: 0,
      name: '1',
    }, {
      label: '订单待支付',
      number: 0,
      name: '13',
    }, {
      label: '发车待验车',
      number: 0,
      name: '12',
    },
  ]

  // 企业主订单模版数据
  const c_primaryOrderConfigData = {
    formData: {
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '订单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
        }, {
          el: 'select',
          itemConfig: {
            label: '客户名称',
            prop: 'customerId',
          },
          elConfig: {
            remoteMethod: this.customerRemoteMethod,
            filterable: true,
            remote: true,
            clearable: true,
            placeholder: '请输入',
            jsxRender: (option) => {
              return <CustomerNameOptionItem data={option} />
            },
            options: {
              label: 'customerName',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const customerItem = this.c_primaryOrderConfigData.formData.list.find((item) => item.itemConfig.prop === 'customerId')
                this.customerConditionList = customerItem?.elConfig?.options?.list
              },
            },
          },
        }, {
          el: 'date-picker',
          itemConfig: {
            label: '订单创建时间',
            prop: 'startTime',
          },
          elConfig: {
            type: 'daterange',
          },
        },
      ],
      dealWithSearch: this.dealWithSearch,
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            label: '订单ID',
            prop: 'id',
            width: 100,
          },
          render: ({ row }) => {
            if (!this.judgePermission('for_rent_sign_contract_ent_rent_order_main_detail')) return row.id
            return (
              <span
                class="a-hover-link"
                onClick={() =>
                  this.handleOrderDetail(row.id)
                }
              >
                {row.id}
              </span>
            )
          },
        },
        {
          name: 'carTotalNum',
          columnProps: {
            label: '租赁车辆数',
            prop: 'carTotalNum',
            width: 100,

          },
        },
        {
          name: 'rentedCarNum',
          columnProps: {
            label: '已租车辆数',
            prop: 'rentedCarNum',
            width: 100,

          },
        },
        {
          name: 'returnCarNum',
          columnProps: {
            label: '订单退车数',
            prop: 'returnCarNum',
            width: 100,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            label: '客户名称',
            prop: 'customerName',
            width: 110,
          },
        },
        {
          name: 'createTime',
          columnProps: {
            label: '订单创建时间',
            prop: 'createTime',
            width: '180',
          },
        },
        {
          name: 'contractStartDate',
          columnProps: {
            label: '合同开始时间',
            prop: 'contractStartDate',
            width: 120,
          },
        },
        {
          name: 'contractEndDate',
          columnProps: {
            label: '合同结束时间',
            prop: 'contractEndDate',
            width: 120,
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '订单状态',
            prop: 'state',
          },
          getText: ({ row }) => selectOptionDict.orderState[row.state],
        },
        {
          name: 'createUserName',
          columnProps: {
            label: '订单创建人',
            prop: 'createUserName',
            width: 110,
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const result = []
            if (this.judgePermission('for_rent_sign_contract_ent_rent_order_main_add_car') && (row.state === 1 || row.state === 2)) {
              result.push({ name: 'addRentOrder', label: '新增租赁车辆', action: () => this.handleAddCarClick(row) })
            }
            if (row.state !== 3 && this.judgePermission('for_rent_sign_contract_ent_rent_order_main_close')) {
              result.push({ name: 'close', label: '关闭订单', action: () => this.getVoidComplete(row) })
            }
            return result
          },
        },
      ],
      apiFn: getLeaseOrderList,
    },
  }

  // 企业主子订单模版数据
  const c_childOrderConfigData = {
    formData: {
      formProps: {
        model: {},
      },
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '子订单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入子订单ID',
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '客户名称',
            prop: 'customerId',
          },
          elConfig: {
            remoteMethod: this.customerRemoteMethod,
            filterable: true,
            remote: true,
            clearable: true,
            placeholder: '请输入',
            jsxRender: (option) => {
              return <CustomerNameOptionItem data={option} />
            },
            options: {
              label: 'customerName',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const customerItem = this.c_childOrderConfigData.formData.list.find((item) => item.itemConfig.prop === 'customerId')
                this.customerConditionList = customerItem?.elConfig?.options?.list
              },
            },
          },
        },
        {
          el: 'CarBrandSeriesModel',
          itemConfig: {
            prop: 'brandSeriesModel',
            ref: 'brandSeriesModelRef',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
          },
          render: 'CarBrandSeriesModel',
        },
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'carId',
          },
          elConfig: {
            remoteMethod: this.carRemoteMethod,
            filterable: true,
            remote: true,
            clearable: true,
            placeholder: '请输入',
            options: { // 下拉数据
              label: 'plateNo',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const carIdItem = this.c_childOrderConfigData.formData.list.find((item) => item.itemConfig.prop === 'carId')
                this.carIdConditionList = carIdItem?.elConfig?.options?.list
              },
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '企业租赁订单ID',
            prop: 'entRentOrderId',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入主订单ID',
            clearable: true,
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '子订单创建时间',
            prop: 'startTime',
          },
          elConfig: {
            clearable: true,
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '计租结束日',
            prop: 'rentFinIsh',
          },
          elConfig: {
            clearable: true,
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '免租结束日',
            prop: 'presentEntTime',
          },
          elConfig: {
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '租赁方案名称',
            prop: 'planId',
          },
          elConfig: {
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
      ],
      dealWithSearch: this.dealWithSearch,
      customizeReset: () => {
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'value',
          key: 'brandSeriesModel',
          data: {},
        })
      },
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '子订单ID',
            width: '120',
          },
          render: ({ row }) => {
            if (!this.judgePermission('for_rent_sign_contract_ent_rent_order_sub_detail')) return row.id
            return (
              <span
                class="a-hover-link"
                onClick={() =>
                  this.toOrderDetailPage(row)
                }
              >
                {row.id}
              </span>
            )
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: '100',
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            width: 160,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户名称',
            width: 110,
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '每期租金',
            width: '100',
          },
        },
        {
          name: 'deposit',
          columnProps: {
            label: '总押金/已收',
            width: '120',
            align: 'left',
            formatter: (row) => `${row.deposit === null ? '0.00' : row.deposit}/${row.receivedDeposit}`,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '子订单创建时间',
            width: '160',
          },
        },
        {
          name: 'startDate',
          columnProps: {
            prop: 'startDate',
            label: '计租开始日',
            width: '120',
          },
        },
        {
          name: 'endDate',
          columnProps: {
            prop: 'endDate',
            label: '计租结束日',
            width: '120',
          },
        },
        {
          name: 'presentEntDate',
          columnProps: {
            label: '免租结束日',
            prop: 'presentEntDate',
            width: 100,
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '子订单状态',
            formatter: (row) => selectOptionDict.leaseOrderState[row.state],
            width: '120',
          },
        },
        {
          name: 'createUser',
          columnProps: {
            prop: 'createUser',
            width: '110',
            label: '订单创建人',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          // 待履约
          //   --订单待确认 0
          //   --发车待验车 1500
          //   --履约中 2500
          // 退车核算
          //   --退车待验车 3500
          //   --订单待核算 4500
          //   --已关闭 5500
          getOperateList: ({ row }) => {
            const btnArr = []
            this.judgePermission('for_rent_sign_contract_ent_rent_order_sub_finance_detail') && row.state === 1000 && btnArr.push({
              name: 'for_rent_sign_contract_ent_rent_order_sub_finance_detail',
              label: '订单支付',
              action: () => this.financeProgress(row),
            })
            this.judgePermission('for_rent_sign_contract_ent_rent_order_sub_to_out_stock') && row.state === 1500 && btnArr.push({
              name: 'for_rent_sign_contract_ent_rent_order_sub_to_out_stock',
              label: '发车验车',
              action: () => this.outInBankPop(row),
            })
            this.judgePermission('for_rent_sign_contract_ent_rent_order_sub_cancel_contract') && btnArr.push({
              name: 'for_rent_sign_contract_ent_rent_order_sub_cancel_contract',
              label: '退车解约',
              action: () => this.closeTheCar(row),
            })
            return btnArr
          },
        },
      ],
      apiFn: PurchaseAndSeven,
    },
  }
  return {
    c_personalTabsList,
    c_enterpriseTabsList,
    c_primaryOrderConfigData,
    c_childOrderConfigData,
    c_signContractTabsList,
  }
}
